import React from 'react';
import AuthLayout from '../auth/AuthLayout';

/**
 * Helper to ensure minimum display duration for loading states
 * @param {number} startMs - Timestamp when loading started
 * @param {number} minMs - Minimum duration in milliseconds
 * @returns {Promise<void>}
 */
export const ensureMinDuration = async (startMs, minMs) => {
  const elapsed = Date.now() - startMs;
  if (elapsed < minMs) {
    await new Promise((resolve) => setTimeout(resolve, minMs - elapsed));
  }
};

const OnboardingLoading = ({
  label = 'Setting up your profile',
  sublabel = 'Pulling in your public details…',
  progressPercent,
  errorMessage,
}) => {
  const showProgress = progressPercent != null;
  const barPercent = showProgress ? Math.min(100, Math.max(0, progressPercent)) : 60;
  const displayPercent = Math.round(barPercent);

  return (
    <AuthLayout
      title={label}
      subtitle={sublabel}
      cardClassName="px-8 py-8"
    >
      <div className="flex flex-col items-center space-y-6">
        {/* Dog Image */}
        <div className="flex justify-center">
          <img
            src="/loadingdog.png"
            alt="Loading"
            className="w-36 h-36 sm:w-44 sm:h-44 object-contain"
          />
        </div>

        {/* Progress Bar */}
        <div className="w-full max-w-xs">
          <div className="h-2 w-full rounded-full bg-slate-200 overflow-hidden">
            <div
              className="h-full bg-[#1B9DA2] rounded-full transition-all duration-300 ease-out"
              style={{ width: `${barPercent}%` }}
            />
          </div>
          {showProgress && (
            <p className="mt-2 text-center text-xs text-slate-500">{displayPercent}%</p>
          )}
        </div>

        {/* Helper Text */}
        <p className="text-sm text-slate-500 text-center">
          This usually takes a few seconds.
        </p>
        {errorMessage && (
          <p className="text-sm text-amber-600 text-center" role="alert">
            {errorMessage}
          </p>
        )}
      </div>
    </AuthLayout>
  );
};

export default OnboardingLoading;
